import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalHeader } from 'reactstrap';
import { IModalProps } from '../../../types';
import { RemoveForm } from '../../FilteredIps/RemoveForm';

export const RemoveFilteredIp: FunctionComponent<IModalProps> = (props) => {
  const { t } = useTranslation();

  const { hideModal, data } = props;

  return (
    <>
      <ModalHeader className="font-montserrat m-0 border-0">
        {t('removeFilteredIp.header', { id: data.id })}
      </ModalHeader>
      <ModalBody>
        <RemoveForm filteredIp={data} onCancel={hideModal} />
      </ModalBody>
    </>
  );
};
